import { Grid2 } from "@mui/material";
import { viewmodeUI } from "../../../../App";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import Export from "./Export";
import Logs from "./Logs";
import Rescan from "./Rescan";
import ToggleColumns from "./ToggleColumns";

export const plusActionsGrid = {
  xl: 5,
  lg: 6,
  md: 12,
  sm: 12,
  xs: 12,
};

const PlusActions = () => {
  const { auth, UI } = useUIBp();
  const viewmode = UI[viewmodeUI] ?? "desktop";

  return (
    <Grid2
      container
      {...{
        columnSpacing: 2,
        justifyContent: viewmode === "desktop" ? "end" : "space-between",
        size: { xl: 7, lg: 6, md: 12, sm: 12, xs: 12 },
      }}
    >
      <ToggleColumns />
      <Export />
      {auth.admin === 1 ? <Rescan /> : null}
      {auth.admin === 1 ? <Logs /> : null}
    </Grid2>
  );
};

export default PlusActions;
